import C from './Constants';
import ArenaImage from './ArenaImage';
import Area from './Area';
import DataStorage from './dataStorage';
import { gsap } from 'gsap';

export default class Arena {
  constructor(props) {
    this.props = props;

    this.el = $('.seat-suggestion .arena');
    this.marker = $('.seat-suggestion .marker');

    if (!this.el || !this.marker) {
      return false;
    }

    this.dataStorage = this.props.dataStorage;
    this.parent = null;

    this.data = null;
    this.sections = null;
    this.poi = null;

    this.selectedArea = null;

    this.arenaImage = null;

    this._onArenaDataLoaded = this._onArenaDataLoaded.bind(this);

       
  }

  loadArenaData() {
    this.data = null;
    let eventId = parseInt($('.seat-suggestion').data('event-id'));
    if (!eventId || isNaN(eventId)) {
      return false;
    }

       

    if (window.arenaInfo) {      
      this._onArenaDataLoaded(window.arenaInfo);
    }
    else {
      let isSeason = document.querySelectorAll('.seat-suggestion').dataset.isSeason      
      $.ajax({
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Content-Type': 'application/json'
        },
        dataType: 'json',
        url: C.BASE_URL + C.ARENA_DATA_URL + eventId + '&isSeason=' + isSeason,
        data: {},
        success: this._onArenaDataLoaded
      });
    }

  }

  loaded() {
    return this.data ? true : false;
  }

  getPOI() {
    return this.poi;
  }

  getSectionByCode(code) {
    return this._getSectionDataByCode(code);
  }

  getStartPosition() {
     return this.data.startPosition;
  }

  /**
   * Private
   */


     

   

  _removeLoader() {
    let loader = $('.seat-suggestion .loader');
    gsap.to(loader, .5, {
      opacity: 0, onComplete: () => {
        loader.remove();
        loader = null;
      }
    });
  }

  _onArenaDataLoaded(data) {
    this.data = data;
    this.sections = this.data.sections;
    this.poi = this.data.poi;

    this._renderArena();

  }

  _renderArena() {
    this.arenaImage = new ArenaImage(this.el.find('.image'));
    this._removeLoader();
    this._setupAreaMap();
    this.props.onArenaDataLoaded();
  }

  _setupAreaMap() {

    let sections = this.arenaImage.getSections();      
      if (sections) {
          sections.each((index, el) => {
              el = $(el);
              let area = new Area(el);

              if (area.validShape()) {

                  let section = this._getSectionDataByCode(area.section);

                  if (section) {
                      area.available = section.available;
                      if (this.props.initialSectionCode === area.section) {
                          this.selectedArea = area;
                          this.props.onSelectInitialSection(section);
                      }
                  } else {
                  }
              } else {
              }

              console.groupEnd();

          });
      }
  }

  _getSectionDataByCode(code) {
    let i = this.sections.length;

    while (i--) {
      let section = this.sections[i];
      if (section.code === code) {
        return section;
      }
    }

    return null;
  }

  _updateMarkerPosition() {
   
    if (!this.selectedArea) {
      this.marker.hide();
      return false;
    }

    let scale = this.arenaImage.getScale();
    let areaCenter = this.selectedArea.getCenter(scale, this.arenaImage.getSvg());
    let x = areaCenter.x - (this.marker.width() * .5);
    let y = areaCenter.y - (this.marker.height() - 7);

    $(".marker").css({ "left": x+"px", "top": y+"px" });
    this.marker.show();
  }

  onResize() {

    if (!this.data) {
      return false;
    }

    this.arenaImage.resize();
    this._updateMarkerPosition();
  }
}
